/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TierType = "CORE" | "ENTERPRISE" | "FREE_FOREVER" | "LITE" | "PRO" | "TRIAL" | "%future added value";
export type BudgetPageHeader_company = {
    readonly id: string;
    readonly tier: TierType | null;
    readonly sageIntacctEnabled: boolean | null;
    readonly sageIntacctTimeRegsFromForecast: boolean | null;
    readonly currency: string | null;
    readonly sageIntacctConnectionEnabled: boolean | null;
    readonly " $refType": "BudgetPageHeader_company";
};
export type BudgetPageHeader_company$data = BudgetPageHeader_company;
export type BudgetPageHeader_company$key = {
    readonly " $data"?: BudgetPageHeader_company$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"BudgetPageHeader_company">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BudgetPageHeader_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tier",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sageIntacctEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sageIntacctTimeRegsFromForecast",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sageIntacctConnectionEnabled",
      "storageKey": null
    }
  ],
  "type": "Company"
};
(node as any).hash = 'afc382a241cb3363b4c23e765811c638';
export default node;
